// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"style_lds-spinner__1DqPM","div-after":"style_div-after__2R7vn"};